import SharedButton from '../../../../shared/buttons/shared-button';

interface PickerTriggerButtonProps {
  hasSelection: boolean;
  onClick: () => void;
  /** Noun used in the label, e.g. "File" gives "Select File" / "Change File". */
  noun: string;
}

/** Large Select/Change button used as a Drive picker `customTrigger`. */
export default function PickerTriggerButton({
  hasSelection,
  onClick,
  noun,
}: PickerTriggerButtonProps) {
  return (
    <SharedButton
      variant={hasSelection ? 'secondary' : 'primary'}
      onClick={onClick}
      sx={{ height: 40, px: 2, fontSize: 16, alignSelf: 'flex-start' }}
    >
      {hasSelection ? `Change ${noun}` : `Select ${noun}`}
    </SharedButton>
  );
}
